import { ErrorToast } from "../components/toastify";
import { AxiosGetMethod } from "../helpers/customAxios";
import HandleLogout from "./handleLogout";

const GetUserLocationList = async () => {
  const UserLocationList = await AxiosGetMethod("org/event/get-customer-cities");
  if (UserLocationList.status === 200) {
    return UserLocationList.data.data;
  } else {
    if (UserLocationList?.status === 401) HandleLogout();
    ErrorToast("Error on fetch locations");
  }
};

export default GetUserLocationList;
